import type { IconProps } from './IconLibrary';

function ShrubIcon({ size = 40, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" {...props}>
      <path
        d="M9 30
           L11 24 L8.5 20 L13 17.5 L12 12 L17 13.5 L20 8 L23 13.5 L28 12 L27 17.5 L31.5 20 L29 24 L31 30
           Q20 33.5 9 30 Z"
        fill="#4f8f5a"
        stroke="#2f2f2f"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ShrubIcon;
